import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Mensaje } from "@/components/mensajes2";
import { Dimmer } from "@/components/spinner";
import { utils, writeFile } from "xlsx";
import { formatoFecha } from "@/util/varios";

export default function ModalImprimirComerciosDeclive(props) {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const anioActual = new Date().getFullYear();
  const anios = Array.from(new Array(7), (val, index) => anioActual - index);
  const [anio, setAnio] = useState(anioActual);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const imprimir = () => {
    try {
      window.open(
        `${op.reportes}/actividadeconomica?reporte=Comercios_Declive&ANIO=${anio}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {}
  };
  const imprimirExcel = () => {
    setLoading(true);
    const endpoint = `${op.conexion}/api/industria/consultar-comercios-declive-excel?anio=${anio}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (
          response.status === 200 &&
          response.data &&
          response.data.length > 0
        ) {
          const worksheet = utils.json_to_sheet(response.data);
          const workbook = utils.book_new();
          utils.book_append_sheet(workbook, worksheet, "Contribuyentes");
          writeFile(
            workbook,
            `Contribuyentes-Declive-${formatoFecha(new Date(), "dd/mm/yyyy")}.xlsx`,
          );
        }
      })
      .catch((error) => {
        console.log(error)
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));
  };
  const salir = () => {
    props.setShow();
  };

  const blanquear = () => {
    setAnio(anioActual);
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      onShow={() => {
        blanquear();
      }}
    >
      <Modal.Header className="azulGradiant py-2 text-uppercase">
        <h3 className="fs-5 fw-bold text-light m-0">
          Imprimir Lista de Contribuyentes en Declive
        </h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between row col-md-12">
          <div className="input-group input-group-sm mb-2 col-md-5">
            <span className="input-group-text text-uppercase">Año:</span>
            <select
              className="form-select form-select-sm"
              value={anio}
              onChange={(e) => setAnio(e.target.value)}
            >
              {anios.map((e, index) => (
                <option key={index} value={e}>
                  {e}
                </option>
              ))}
            </select>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn-sm rounded-pill btn btn-info col-md-2"
          onClick={() => imprimirExcel()}
        >
          <i className="fas fa-file" /> Excel
        </button>
        <button
          className="btn-sm rounded-pill btn btn-primary col-md-3"
          onClick={() => imprimir()}
        >
          <i className="fas fa-print"></i> Imprimir
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close"></i> Salir
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Dimmer active={loading} inverted />
    </Modal>
  );
}
